module.exports = __webpack_public_path__ + "static/img/title-icon.33abffdf.svg";